import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container no-user-select cluster-view"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XLoadingIcon = _resolveComponent("XLoadingIcon")!
  const _component_TopMatter = _resolveComponent("TopMatter")!
  const _component_EmptyContent = _resolveComponent("EmptyContent")!
  const _component_DynamicTopMatter = _resolveComponent("DynamicTopMatter")!
  const _component_ClusterGrid = _resolveComponent("ClusterGrid")!
  const _component_Timeline = _resolveComponent("Timeline")!

  return (_ctx.noParams)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_XLoadingIcon, {
              key: 0,
              class: "loading-icon centered"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_TopMatter),
        (!_ctx.items.length && !_ctx.loading)
          ? (_openBlock(), _createBlock(_component_EmptyContent, { key: 1 }))
          : _createCommentVNode("", true),
        _createVNode(_component_ClusterGrid, {
          items: _ctx.items,
          minCols: _ctx.minCols,
          maxSize: _ctx.maxSize,
          focus: true
        }, {
          before: _withCtx(() => [
            _createVNode(_component_DynamicTopMatter, {
              class: "cv-dtm",
              ref: "dtm"
            }, null, 512)
          ]),
          _: 1
        }, 8, ["items", "minCols", "maxSize"])
      ]))
    : (_openBlock(), _createBlock(_component_Timeline, { key: 1 }))
}